/**
 * Component override helper — extracts keyed override props.
 *
 * Canonical implementation from:
 * - packages/hoi-poi-ui/src/utils/overrides.js
 * - packages/ssm-web5/src/utils/overrides.js
 *
 * NOTE: The React hook `useClasses` that co-exists in hoi-poi-ui's version
 * stays in hoi-poi-ui because it depends on React and JSS.
 */

/**
 * Given a `props` object and an array of `keys`, return an object mapping
 * each key to `props[key]` (defaulting to `{}`).
 *
 * Useful for extracting sub-component override props in UI libraries.
 *
 * @param {Object} [props={}]
 * @param {string[]} [keys=[]]
 * @returns {Object}
 */
export function getOverrides(props = {}, keys = []) {
    return keys.reduce((result, key) => {
        result[key] = props[key] || {};
        return result;
    }, {});
}
